import { PageContext } from '../context/page-context';
import { NotesMasterProps } from '../props/page/notes-master-props';
import { NotesMasterStore } from '../store/notes-master-store';
import { PageMutationAPI } from '../api/page-mutation-api';
import { PageDataModel } from './page-data-model';
import type { IEventManager } from '../manager/event-manager';
import type { INotesMasterProps } from '../props/page/notes-master-props';
import type { INotesMasterData } from '../data';
import type { RestrictedDataModel } from './data-model';
import type { PresentationDataModel } from './presentation-data-model';

export class NotesMasterDataModel extends PageDataModel<INotesMasterData, INotesMasterProps> {
    public store: NotesMasterStore;
    public props: INotesMasterProps;
    public api: PageMutationAPI<NotesMasterDataModel>;
    public context: PageContext;

    public constructor(data: INotesMasterData, events: IEventManager, public parent: PresentationDataModel) {
        super(events, parent);

        this.context = new PageContext(data.type);
        this.store = new NotesMasterStore(data, events, this.context, this);
        this.props = new NotesMasterProps(this.store.data, this.context);
        this.api = new PageMutationAPI(this, events);

        this.context.setPresentation(this.parent);
        this.context.setPage(this);
        this.context.setTarget(this);
    }
}

export { INotesMasterProps };
export type INotesMasterDataModel = RestrictedDataModel<NotesMasterDataModel>;
